export default __webpack_public_path__ + "static/media/footerLogo.78ccf271.svg";